import _styled from "styled-components";
import Image from 'next/image';
import { customImageLoader, getAssetSrc } from '@restworld/utils-common';
/* eslint-disable-next-line */

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var Wrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "not-found__Wrapper",
  componentId: "sc-1n0jn1e-0"
})(["", ";", ";"], {
  "display": "flex",
  "height": "100%",
  "width": "100%",
  "flexDirection": "column",
  "alignItems": "center",
  "justifyContent": "center",
  "gap": "1.5rem"
}, function (_ref) {
  var wrapperStyles = _ref.wrapperStyles;
  return wrapperStyles;
});

export function NotFound(_ref2) {
  var mainTitle = _ref2.mainTitle,
      subTitle = _ref2.subTitle,
      ctaButtons = _ref2.ctaButtons,
      wrapperStyles = _ref2.wrapperStyles;
  return /*#__PURE__*/_jsxs(Wrapper, {
    wrapperStyles: wrapperStyles,
    children: [/*#__PURE__*/_jsx(Image, {
      src: getAssetSrc('/utils-assets/not-found.svg'),
      width: 238,
      height: 220,
      loader: customImageLoader,
      alt: "not-found"
    }), !!mainTitle && /*#__PURE__*/_jsx(_StyledH, {
      children: mainTitle
    }), !!subTitle && /*#__PURE__*/_jsx(_StyledH2, {
      children: subTitle
    }), ctaButtons]
  });
}
export default NotFound;

var _StyledH = /*#__PURE__*/_styled("h5").withConfig({
  displayName: "not-found___StyledH",
  componentId: "sc-1n0jn1e-1"
})({
  "justifyContent": "flex-start",
  "alignSelf": "stretch",
  "textAlign": "center",
  "fontSize": "1rem",
  "lineHeight": "1.5rem",
  "fontWeight": "600",
  "--tw-text-opacity": "1",
  "color": "rgb(28 28 51 / var(--tw-text-opacity))"
});

var _StyledH2 = /*#__PURE__*/_styled("h5").withConfig({
  displayName: "not-found___StyledH2",
  componentId: "sc-1n0jn1e-2"
})({
  "justifyContent": "flex-start",
  "alignSelf": "stretch",
  "textAlign": "center",
  "fontSize": "1rem",
  "lineHeight": "1.5rem",
  "fontWeight": "500",
  "--tw-text-opacity": "1",
  "color": "rgb(102 102 118 / var(--tw-text-opacity))"
});